module.exports = __webpack_public_path__ + "img/regLogo.8f989bfe.png";